import { plus, dividedBy, decimalPlaces } from './number';

export function getSummaries({ param, report, allPayField }) {
  const { columns, data } = param;
  const sums = [];
  columns.forEach((column, index) => {
    if (index === 0) {
      sums[index] = '合计';
      return;
    }

    if (column.type === 'isNotSummary') return;
    const list = data.filter(item => !item.isNotSummary);

    if (column.property === 'all_pay') {// 编辑页获取总计
      sums[index] = report[allPayField];
      return;
    }

    if (column.property === 'commission') {// 编辑页获取门店提成
      sums[index] = report.store_income;
      return;
    }

    const values = data.map(item => +item[column.property]);
    if (!values.every(value => isNaN(value))) {
      sums[index] = values.reduce((prev, curr) => {
        const value = +curr;
        return isNaN(value) ? prev : plus(prev, curr);
      }, 0);
      if (column.type === 'money') sums[index] = dividedBy(sums[index], 100);
      if (column.type === 'average' && index === sums.length - 1) {
        sums[index] = dividedBy(sums[index], list.length);
        sums[index] = decimalPlaces(sums[index]);
      }
    } else {
      sums[index] = '';
    }
  });

  return sums;
}
